import { SessionContext } from '#pplx/frontend/auth/SessionContext.js';
import { useContext } from 'react';
export function useSession() {
    const context = useContext(SessionContext);
    if (!context) {
        throw new Error('useSession must be used within a SessionProvider');
    }
    return context;
}
//# sourceMappingURL=useSession.js.map